
export const profiles = {
  title: 'Perfiles de Personalidad',
  subtitle: 'Descubre los 19 perfiles únicos de personalidad y comprende cómo cada tipo aborda el trabajo, la comunicación y la colaboración.',
  exampleChart: 'Perfil de Ejemplo',
  patternCode: 'Código de Patrón',
  seeAllProfiles: 'Ver Todos los Perfiles',
  backToAssessment: 'Realizar Evaluación',
  averageScores: 'Puntuaciones Promedio',
  basedOnAssessments: 'Basado en {{count}} evaluaciones',
  exampleData: 'Datos de ejemplo',
  contributors: {
    title: 'Contribuyentes ({{count}})',
    andMore: 'y {{count}} más...'
  }
};
